"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronType = void 0;
var CronType;
(function (CronType) {
    CronType["SCHEDULE_LOTTERY_ROUND"] = "SCHEDULE_LOTTERY_ROUND";
    CronType["SCHEDULE_RAFFLE_ROUND"] = "SCHEDULE_RAFFLE_ROUND";
})(CronType || (exports.CronType = CronType = {}));
//# sourceMappingURL=cron.js.map